import IDocSection from "./IDocSection";

export enum ItemType {
  api = "api",
  doc = "doc",
  console = "console",
  reference = "reference",
  code = "code",
  download = "download",
}

export default interface ITabMenuContentItem {
  name: string;
  type?: ItemType;
  href?: string;
  exactMatches?: Array<string>;
  startMatches?: Array<string>;
  docSection: IDocSection;
}
